import { combineReducers } from "redux";
import { uploadFileReducer, uploadModel, slice, uploadFileSlice } from "./uploadReducer";
import { translationModelSlice } from "./translateReducer";
import segmentsReducer from "./segments";
import { languageSlice } from "./languageReducer";
import { stateSlice } from "../reducers/stateManagmentReducer";
import validationReducer from "./validationReducer";
import openEditorReducer from "./openEditorTargetId";

const rootReducer = combineReducers({
  uploadModel: slice.reducer,
  file: uploadFileSlice.reducer,
  languages: languageSlice.reducer,
  model: translationModelSlice.reducer,
  segments: segmentsReducer,
  stateMng: stateSlice.reducer,
  validation: validationReducer,
  opendEditorTargetId: openEditorReducer,
});

export default rootReducer;
